/**
 * Shared seq-conflict property comparison for CRM property saves.
 *
 * On a 409 seq collision, both useFormState (batch save) and
 * useUpdateCrmProperty (single-property save) refetch the object and ask the
 * same question: did someone else change one of the properties we're trying
 * to save? Centralizing that check keeps a fix to the comparison from having
 * to be duplicated across both hooks.
 */
import { valuesEqual } from '../utils/valuesEqual';

/**
 * Returns the subset of `pendingKeys` whose value in `freshProperties`
 * differs (per `valuesEqual`) from the corresponding value in
 * `baselineProperties`. An empty result means none of the properties we're
 * trying to save were touched by someone else, so it's safe to retry against
 * the fresh seq; a non-empty result means a real conflict occurred.
 */
export function getConflictingPropertyKeys(
  pendingKeys: string[],
  freshProperties: Record<string, { value: unknown } | undefined>,
  baselineProperties: Record<string, unknown>
): string[] {
  return pendingKeys.filter(
    key => !valuesEqual(freshProperties[key]?.value, baselineProperties[key])
  );
}
